var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
if (typeof Promise.withResolvers === "undefined") {
  if (typeof window !== "undefined") {
    window.Promise.withResolvers = function() {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
  } else {
    global.Promise.withResolvers = function() {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
  }
}
function wrapPromisesOnce(promises) {
  return promises.map((original) => {
    const wrapped = original.then((result) => ({ original, result, error: void 0 })).catch((error) => ({ original, result: void 0, error }));
    return { original, wrapped };
  });
}
__name(wrapPromisesOnce, "wrapPromisesOnce");
async function getFirstResolved(metas) {
  if (metas.length === 0) {
    throw new Error("getFirstResolved: empty promises array");
  }
  return Promise.race(metas.map((meta) => meta.wrapped));
}
__name(getFirstResolved, "getFirstResolved");
async function* processPromisesSequentially(promises) {
  if (promises.length === 0) {
    return;
  }
  const promiseMetas = wrapPromisesOnce(promises);
  const total = promiseMetas.length;
  let completed = 0;
  while (promiseMetas.length > 0) {
    console.log("processPromisesSequentially before getFirstResolved. promiseMetas.length =", promiseMetas.length);
    const { original, result, error } = await getFirstResolved(promiseMetas);
    console.log("processPromisesSequentially after getFirstResolved. result =", result, "error =", error);
    const currentIndex = promiseMetas.findIndex((m) => m.original === original);
    if (currentIndex !== -1) {
      promiseMetas.splice(currentIndex, 1);
    }
    completed++;
    if (error) {
      console.error("processPromisesSequentially: Promise rejected with error:", error);
    }
    yield {
      result,
      progress: {
        total,
        completed,
        remaining: promiseMetas.length,
        currentIndex
      }
    };
  }
}
__name(processPromisesSequentially, "processPromisesSequentially");
export {
  processPromisesSequentially
};
//# sourceMappingURL=promise.js.map
